import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTrialStatus } from '../../hooks/useTrialStatus';
import { useTheme } from '../../context/ThemeContext';
import LogoDark from '../../assets/images/Logo_Dark_Theme.png';
import LogoLight from '../../assets/images/Logo_Light_Theme.png';
import './Sidebar.css';

const MENU_ITEMS = [
  { path: '/dashboard', emoji: '🏠', label: 'Dashboard' },
  { path: '/productivity', emoji: '⚡', label: 'Productivity' },
  { path: '/wellness', emoji: '🧘‍♂️', label: 'Wellness' },
  { path: '/growth', emoji: '🎯', label: 'Growth' },
  { path: '/finances', emoji: '💰', label: 'Finances' },
  { path: '/social', emoji: '👥', label: 'Social' }
];

const Sidebar = () => {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const { isActive, formatRemainingTime, isLoading, subscriptionStatus, getStatusBadge } = useTrialStatus();
  const { theme } = useTheme();

  const renderStatusBadge = () => {
    if (isLoading) return null;
    if (isActive === null) return null;

    const badgeClass = subscriptionStatus === 'active' 
      ? 'subscribed'
      : isActive ? 'active' : 'expired';

    return (
      <div className="trial-status">
        <div className={`status-badge ${badgeClass}`}>
          {getStatusBadge()}
        </div>
        <div className="status-info">
          {formatRemainingTime()}
        </div>
      </div>
    );
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="logo">
          <img 
            src={theme === 'dark' ? LogoDark : LogoLight} 
            alt="Logo" 
            className="logo-image"
          />
        </div>
      </div>

      <div className="sidebar-content">
        <nav className="sidebar-nav">
          {MENU_ITEMS.map(({ path, emoji, label }) => (
            <Link
              key={path}
              to={path}
              className={`nav-item ${pathname === path ? 'active' : ''}`}
            >
              <span className="nav-emoji">{emoji}</span>
              <span>{label}</span>
            </Link>
          ))}
        </nav>

        <div className="sidebar-footer">
          {renderStatusBadge()}

          <Link to="/profile" className="user-info">
            <div className="user-avatar">
              {user?.photoURL ? (
                <img src={user.photoURL} alt="Profile" />
              ) : (
                <span>{user?.displayName?.[0] || user?.email?.[0]}</span>
              )}
            </div>
            <div className="user-details">
              <div className="user-name">
                {user?.displayName || 'User'}
              </div>
              <div className="user-email">
                {user?.email}
              </div>
            </div>
          </Link>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar; 